<template>
  <div>
    <div class="v-label">{{ label }}</div>
    <div class="file-manager-btn">
      <file-manager :directory="directoryName"></file-manager>
    </div>
    <Editor
        :tinymce-script-src="tinymceScriptSrc"
        v-model="localValue"
        :init="editorConfig"
        class="mb-2"
    />
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import FileManager from "@/components/File/FileManager.vue";

export default {
  name: 'TextEditor',
  components: { FileManager, Editor },
  props: {
    label: String,
    directoryName: String,
    value: String,
    /** Unused when self-hosting; kept for backward compatibility with parent components. */
    apiKey: {
      type: String,
      default: '',
    },
    direction: {
      type: String,
      default: 'ltr', // Default text direction
      validator: (val) => ['ltr', 'rtl'].includes(val),
    },
  },
  computed: {
    /** Public folder URL root (Vue CLI `public/`), respects `publicPath` when set. */
    tinymcePublicRoot() {
      const base = (process.env.BASE_URL || '/').replace(/\/$/, '');
      return `${base}/plugins`;
    },
    tinymceScriptSrc() {
      return `${this.tinymcePublicRoot}/tinymce.min.js`;
    },
    editorConfig() {
      return {
        base_url: this.tinymcePublicRoot,
        suffix: '.min',
        toolbar_sticky: true,
        toolbar_sticky_offset: 63,
        toolbar_mode: 'sliding',
        plugins: [
          'advlist', 'anchor', 'autolink', 'autoresize', 'autosave',
          'charmap', 'code', 'codesample', 'directionality', 'emoticons',
          'fullscreen', 'help', 'hr', 'image', 'imagetools', 'importcss',
          'insertdatetime', 'link', 'lists', 'media', 'nonbreaking', 'pagebreak',
          'paste', 'preview', 'quickbars', 'save', 'searchreplace', 'table',
          'visualblocks', 'visualchars', 'wordcount'
        ],
        toolbar:
            'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | ' +
            'link image media table mergetags | addcomment showcomments | ' +
            'spellcheckdialog a11ycheck typography | align lineheight | ' +
            'checklist numlist bullist indent outdent | emoticons charmap | removeformat',

        // quickbars_selection_toolbar: 'bold italic underline | link | setCustomId',

        directionality: this.direction,

        setup: (editor) => {
          editor.ui.registry.addButton('setCustomId', {
            text: 'Set Custom ID',
            onAction: () => {
              const selectedNode = editor.selection.getNode();
              const selectedText = editor.selection.getContent({ format: 'html' });
              if (!selectedText) {
                alert('Please select some text first.');
                return;
              }

              let currentId = '';
              let nodeWithId = selectedNode.closest('[id]');

              if (selectedNode.id) {
                currentId = selectedNode.id;
              } else if (nodeWithId) {
                currentId = nodeWithId.id;
              }

              const customId = prompt('Enter a custom ID for the selected text:', currentId);
              if (customId !== null) {
                if (customId.trim() === '') {
                  editor.selection.setContent(selectedText);
                } else {
                  const spanWithId = `<span id="${customId.trim()}">${selectedText}</span>`;
                  editor.selection.setContent(spanWithId);
                }
              }
            }
          });
        },
      };
    },

    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style scoped>
.file-manager-btn {
  float: right;
  position: absolute;
  padding: 5px;
  z-index: 10000;
}
</style>